import { useEffect, useMemo } from 'react';

import { Formik } from 'formik';

import CreateFormArray from './CreateFormArray';
import useCreateSchema from './useCreateSchema';

const CreateDiscounts = ({
  participants,
  setParticipants = () => {},
  setIsFormValid,
  selectedSessions = [],
  discountOptions = {}
}) => {
  const validationSchema = useCreateSchema();

  const optionalSessions = useMemo(
    () =>
      selectedSessions
        .filter((session) => session.optionalSession)
        .map((session) => ({ id: session.id, name: session.name })),
    [selectedSessions]
  );

  const participantWithoutBookingPerson = participants.filter(
    (participant) => !participant.isBookingPerson
  );

  const initialValues = useMemo(() => {
    return {
      discounts: participantWithoutBookingPerson.map((participant) => {
        return {
          eventDiscount:
            participant?.discounts?.eventDiscount !== undefined
              ? parseInt(participant?.discounts?.eventDiscount) || 0
              : discountOptions?.event?.find((item) => item?.isDefault)?.id || 0,
          optionalSessionsDiscounts: optionalSessions.map((optionalSession) => ({
            value:
              participant?.discounts?.optionalSessionsDiscounts?.find(
                (item) => item?.sessionId === optionalSession?.id
              )?.value ??
              discountOptions?.optionalSessions
                ?.find((item) => item?.sessionId === optionalSession?.id)
                ?.discounts?.find((temp) => temp?.isDefault)?.id ??
              0,
            sessionId: optionalSession?.id,
            sessionName: optionalSession?.name
          })),
          name: `${participant?.generalInformation?.firstName || ''} ${participant?.generalInformation?.lastName || ''}`,
          id: participant.id
        };
      })
    };
  }, [participants, optionalSessions, discountOptions]);

  const bookingEventDiscountsOptions = discountOptions?.event;

  const onSubmit = (values, { setSubmitting }) => {
    setParticipants((participants) =>
      participants.map((participant) => {
        const discountForParticipant = values.discounts.find(
          (discount) => participant.id === discount.id
        );
        if (discountForParticipant) {
          return { ...participant, discounts: discountForParticipant };
        } else {
          return participant;
        }
      })
    );
    setSubmitting(false);
  };

  useEffect(() => {
    // sync order summary with initial values
    const timeoutId = setTimeout(() => {
      onSubmit(initialValues, { setSubmitting: () => {} });
    }, 500);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <Formik
        enableReinitialize
        validateOnMount
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setValues, setFieldValue }) => {
          return (
            <>
              <CreateFormArray
                values={values}
                setIsFormValid={setIsFormValid}
                setValues={setValues}
                setFieldValue={setFieldValue}
                bookingEventDiscountsOptions={bookingEventDiscountsOptions}
                discountOptions={discountOptions}
                optionalSessions={optionalSessions}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateDiscounts;
